import { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import Button from 'components/UI/Button';
import { formatDigitalLoanMoney } from '../utils/moneyInput';
import {
  SCHEDULE_PREVIEW_COUNT,
  readScheduleDate,
  readSchedulePayment,
} from '../utils/paymentSchedule';

const PaymentScheduleModal = ({
  literals,
  schedule = [],
  onClose,
}) => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll
    ? schedule
    : schedule.slice(0, SCHEDULE_PREVIEW_COUNT);
  const hasMore = schedule.length > SCHEDULE_PREVIEW_COUNT && !showAll;

  return (
    <Modal
      className='digital-loan-schedule-modal'
      title={literals.scheduleTitle}
      position='center'
      showCloseButton={false}
      onClose={onClose}
    >
      {schedule.length === 0 && (
        <p className='digital-loan-phase2__body'>{literals.emptySchedule}</p>
      )}
      {schedule.length > 0 && (
        <table className='digital-loan-schedule'>
          <thead>
            <tr>
              <th scope='col'>{literals.scheduleDate}</th>
              <th scope='col'>{literals.schedulePayment}</th>
            </tr>
          </thead>
          <tbody>
            {visible.map((row) => {
              const date = readScheduleDate(row);
              return (
                <tr key={`${row.position || ''}-${date}`}>
                  <td>{date || literals.emptyValue}</td>
                  <td>
                    {formatDigitalLoanMoney(
                      readSchedulePayment(row),
                      literals.emptyValue,
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      {hasMore && (
        <Button
          text={literals.seeMore}
          type='link'
          onClick={() => setShowAll(true)}
        />
      )}
      <Button text={literals.understood} onClick={onClose} />
    </Modal>
  );
};

PaymentScheduleModal.propTypes = {
  literals: PropTypes.object.isRequired,
  schedule: PropTypes.array,
  onClose: PropTypes.func.isRequired,
};

export default PaymentScheduleModal;
